<template>
  <div class="index">
    <disks :disks="$store.state.disks"></disks>
  </div>
</template>

<script>
import disks from "../../components/disks";
export default {
  name: "Page",
  components: { disks },
  data() {},
  methods: {},
  computed: {},
  mounted() {},
};
</script>
<style scoped lang="less" src="./index.less">
</style>
